// extracted by mini-css-extract-plugin
module.exports = {"container":"sub_title_container__1l74E","title":"sub_title_title__11eXh","description":"sub_title_description__ronp4"};